/**
 * Generate a random integer that is under Number.MAX_SAFE_INTEGER
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/MAX_SAFE_INTEGER
 * @param opts.asNumber - if true, return a number instead of a string
 */
export function genIdAsNumber() {
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)
}

/**
 * Same as genIdAsNumber but returns a string instead of a number
 */
export function genId() {
  return genIdAsNumber().toString()
}

export const genUuid = async () => {
  if (typeof self.crypto.randomUUID === 'function') {
    return self.crypto.randomUUID()
  }
  const uuidv4 = (await import('uuid')).v4
  return uuidv4()
}

/**
 * Sync variant of genUuid — use when a Promise is not acceptable (e.g. before
 * an async retry loop where the ID must stay stable across attempts).
 */
export function safeUUID(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID()
  }
  return genRandomString(32)
}

// by default genRandomString uses an alphanumeric character set
export const genRandomString = (
  length: number,
  chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
) => {
  let result = ''
  for (let i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)]
  return result
}
